import { render, staticRenderFns } from "./chooseBar.vue?vue&type=template&id=3c50768a&scoped=true&"
import script from "./chooseBar.vue?vue&type=script&lang=js&"
export * from "./chooseBar.vue?vue&type=script&lang=js&"
import style0 from "./chooseBar.vue?vue&type=style&index=0&id=3c50768a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c50768a",
  null
  
)

export default component.exports